import { lazy, Suspense } from "react";
import CircularLoader from "../../../customs/loader/main";

const Main = lazy(() => import("../../../components/settings/learningTraining/eventType/main"));

const EventType = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default EventType;

